import { HttpClient } from "@angular/common/http";
import { HttpService } from "../http.service";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs";
import { of } from "rxjs";

@Injectable({
    providedIn: 'root'
  })

export class AdminFinanceService extends HttpService<any, any > {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'report');
  }

  getOrdersStats() {
    return this.getAll('orders/count-of-orders');
  }

  getPaymentsByGroup(startDate?: Date, endDate?: Date) {
    if (startDate && endDate) {
      const startDateStr = this.formatDateLocal(startDate);
      const endDateStr = this.formatDateLocal(endDate);
      return this.getAll(`orders/group-by-payments?start_date=${startDateStr}&end_date=${endDateStr}`);
    }
    return this.getAll('orders/group-by-payments');
  }

  getOrdersOverTimeStats(startDate?: Date, endDate?: Date) {
    if (startDate && endDate) {
      const startDateStr = this.formatDateLocal(startDate);
      const endDateStr = this.formatDateLocal(endDate);
      return this.getAll(`orders/orders-over-time?start_date=${startDateStr}&end_date=${endDateStr}`);
    }
    return this.getAll('orders/orders-over-time');
  }

  getRevenueOverTimeStats(startDate?: Date, endDate?: Date) {
    if (startDate && endDate) {
      const startDateStr = this.formatDateLocal(startDate);
      const endDateStr = this.formatDateLocal(endDate);
      return this.getAll(`sales/chart-revenue?start_date=${startDateStr}&end_date=${endDateStr}`);
    }
    return this.getAll('sales/chart-revenue');
  }

  private formatDateLocal(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }


  getSaleReportsStats() {
    return this.getAll('sales/summary');
  }

  getProfitReportsStats() {
    return this.getAll('profit/kpis');
  }

  getProfitOverTimeStats(startDate?: Date, endDate?: Date) {
    if (startDate && endDate) {
      const startDateStr = this.formatDateLocal(startDate);
      const endDateStr = this.formatDateLocal(endDate);
      return this.getAll(`profit/trend?start_date=${startDateStr}&end_date=${endDateStr}`);
    }
    return this.getAll('profit/trend');
  }
  getStockReportsStats() {
    return this.getAll('stock/analytics');
  }

  getStockTrackingStats(body: any) {
    if(body?.category_id){
      return this.getAll(`stock/chart?category_id=${body.category_id}`);
    }
    return this.getAll(`stock/chart`);
  }

  getStockTableData() {
    return this.getAll('stock/table');
  }

  getReturnsReportsSummary() {
    return this.getAll('return/summary');
  }

  getAllStockOrders(body: any): Observable<any | null> {
    return this.filterAllRports(body,'stock/table')
}


getReturnsReport(body: any): Observable<any | null> {
  return this.filterAllRports(body,'return/filter');
}



}
